<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="shadow overflow-hidden sm:rounded-lg">
            <div class="relative divide-y divde-gray-200">
              <slot name="before-table" :set-loading="setLoading" />
              <table class="min-w-full divide-y divide-gray-200">
                <OrderListHeader />
                <tbody class="relative">
                  <template v-for="item in orders">
                    <OrderListItem
                      :key="item.id"
                      :order="item"
                      :softone-api-services="softoneApiServices"
                    />
                  </template>
                </tbody>
              </table>
              <slot name="after-table" :set-loading="setLoading" />
              <div
                v-show="loading"
                class="absolute inset-0 w-full h-full bg-white bg-opacity-75 flex items-center justify-center"
              >
                <Loader />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderListHeader from './order-list-header.vue';
import OrderListItem from './order-list-item.vue';

export default {
  components: {
    OrderListHeader,
    OrderListItem,
  },
  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    softoneApiServices: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    setLoading(loading = true) {
      this.loading = loading;
    },
  },
};
</script>
